import React from 'react';
import '../Pedidos/Pedidos.css';

import InfoPedido from '../Pedidos/InfoPedido';
import InfoCliente from '../Pedidos/InfoCliente';
import TablaPedidos from '../Pedidos/TablaPedidos';

import {
    AppBar, Box, Card, CardContent, Container, Dialog, Grid,
    IconButton, Slide, Toolbar, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const MedicalOrderDetailDialog = ({ open, onClose, order, setOrder }) => (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative', backgroundColor: '#04A6E1' }}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={onClose} aria-label="Cerrar">
                    <CloseIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
        <Container maxWidth="xxl" sx={{ mt: 5, mb: 5 }}>
            <Typography variant="h5">Pedido: {order.order_num}</Typography>
            <Typography variant="button"># Pedido Odoo: {order.odoo_order_name}</Typography>
            <Typography variant="subtitle1">Fecha del pedido: {order.full_order_date}</Typography>
            <Typography variant="subtitle1">
                Pagado con: <b style={{ color: '#3498DB' }}>{order.payment?.method || 'No disponible'}</b>
            </Typography>

            <Box sx={{ mt: 5 }}>
                <TablaPedidos selectedOrder={order} />
            </Box>

            <Box sx={{ mt: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                        <Card className="card__pedidos">
                            <CardContent>
                                <Typography gutterBottom variant="h5" sx={{ fontWeight: 600 }}>
                                    Información del cliente
                                </Typography>
                                <InfoCliente selectedOrder={order} />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                        <Card className="card__pedidos">
                            <CardContent>
                                <Typography gutterBottom variant="h5" sx={{ fontWeight: 600 }}>
                                    Información del pedido
                                </Typography>
                                <InfoPedido selectedOrder={order} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    </Dialog>
);

export default MedicalOrderDetailDialog;
